import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import clsx from 'clsx';
import MaterialRadio from '@material-ui/core/Radio';
import { RadioButtonChecked, RadioButtonUnchecked } from '@material-ui/icons';
import { makeStyles } from '../../lib/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(1),
  },
  icon: {
    height: 18,
    width: 18,
  },
  uncheckedIcon: {
    color: theme.palette.grey[300],
  },
}));

const Radio = forwardRef(function Radio(
  { className, disabled, onChange, required, color, checked, value, ...restProps },
  ref
) {
  const { root, icon, uncheckedIcon } = useStyles();

  return (
    <MaterialRadio
      icon={<RadioButtonUnchecked className={clsx(icon, uncheckedIcon)} />}
      checkedIcon={<RadioButtonChecked className={icon} />}
      className={clsx(root)}
      ref={ref}
      disableRipple
      checked={checked}
      value={value}
      {...restProps}
      color={color}
      disabled={disabled}
      onChange={onChange}
      required={required}
    />
  );
});

Radio.propTypes = {
  className: Proptypes.string,
  color: Proptypes.string,
  disabled: Proptypes.bool,
  name: Proptypes.string,
  onChange: Proptypes.func,
  required: Proptypes.bool,
  checked: Proptypes.bool.isRequired,
  value: Proptypes.oneOfType([Proptypes.bool, Proptypes.string, Proptypes.number]).isRequired,
};

Radio.defaultProps = {
  className: '',
  color: 'primary',
  disabled: false,
  name: '',
  onChange: null,
  required: false,
};

Radio.displayName = 'Radio';

export default Radio;
